import React from 'react';
import { observer } from 'mobx-react-lite';
import { debounce } from '../../../jira-common/utils';
import { toSelectOption } from '../../models/SelectOption';
import { QuestionStore, toChoiceQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditDropdown } from './edit/EditDropdown';
import { ViewDropdown } from './view/ViewDropdown';
export var Dropdown = observer(function (props) {
  var _questionStore$issueF;
  var id = props.id,
    questionStore = props.questionStore,
    formStore = props.formStore,
    displayMode = props.displayMode,
    customComponents = props.customComponents;
  var availableOptions = questionStore.availableOptions();
  var currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
  var currentOption = questionStore.getAnswerChoicesAsObjects()[0];
  var currentChoiceId = currentOption === null || currentOption === void 0 ? void 0 : currentOption.value;
  var hasOtherChoice = !!questionStore.otherChoiceId;
  var showEditComponent = displayMode === DisplayMode.Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2;
    var onChange = function onChange(value) {
      var selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
      var newChoiceIds = selectedChoiceId ? [selectedChoiceId] : [];
      questionStore.setAnswer({
        text: hasOtherChoice && selectedChoiceId === questionStore.otherChoiceId ? toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).text : '',
        choices: newChoiceIds,
        choiceObjects: value ? [QuestionStore.optionToChoice(value)] : []
      });
    };
    var otherChoiceSelected = hasOtherChoice && currentChoiceId === questionStore.otherChoiceId;
    var loadChoicesAsync = questionStore.isAsyncChoicesField ? debounce(function (inputValue, callback) {
      formStore.loadChoicesAsync(questionStore.id, inputValue).then(function (_) {
        return callback(questionStore.choices.map(toSelectOption));
      });
    }, 500) : undefined;
    var onOtherChoiceTextChange = function onOtherChoiceTextChange(event) {
      questionStore.setAnswer({
        text: event.target.value,
        choices: toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).choices
      });
    };
    return /*#__PURE__*/React.createElement(EditDropdown, {
      id: id,
      key: "".concat(id, "-").concat(questionStore.dependentFieldChangedCount),
      options: availableOptions,
      value: currentOption,
      loading: questionStore.loading,
      loadOptions: loadChoicesAsync,
      onChange: onChange,
      hasOtherOption: hasOtherChoice,
      otherOptionSelected: otherChoiceSelected,
      otherOptionText: currentAnswer.text,
      onOtherOptionTextChange: onOtherChoiceTextChange,
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      customComponents: customComponents,
      label: (_questionStore$formQu2 = questionStore.formQuestion) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.label
    });
  }
  return /*#__PURE__*/React.createElement(ViewDropdown, {
    id: id,
    options: availableOptions,
    value: currentOption,
    hasOtherOption: hasOtherChoice,
    otherOptionText: currentAnswer.text,
    displayMode: displayMode
  });
});